/* eslint-disable */
<template>

<div class="admin-overview">
        <buttonc type="footer rectangle" icon="fa-refresh" :label="$t('global.view.loadUsers')" @click="getUsers()" style="position: absolute; margin-top: -30px"/>
        <buttonc type="footer rectangle" :disabled="uuids.length === 0"  :label="$t('global.view.loadUuids') + (uuids.length > 0 ? ' (' + uuids.length + ')' : '')" @click="getMultiUserInfo()" style="position: absolute; margin-left: 150px; margin-top: -30px"/>
		<div class="row">
            <div class="entry" style="width: calc(100% - 30px); margin-left: 15px;">
                <buttonc type="footer" :label="$t('global.view.page')" style="width: 150px; height: 30px; margin-right: 0px"/>
                <input type="number" autocomplete="off" v-model="currentPage"/>
            </div>
            <div class="entry" style="width: calc(100% - 30px); margin-left: 15px;">
                <buttonc type="footer" :label="$t('global.view.addUuid')" style="width: 150px; height: 30px; margin-right: 0px"/>
                <input @keydown="addUUID($event)" type="text" autocomplete="off" v-model="currentUUID"/>
            </div>
			<div class="entry uuid" v-for="(uuid, index) in uuids" :key="uuid" v-bind:class="{last: index === uuids.length - 1}">
                <labelc :text="uuid" style="width: 100%"/>
                <buttonc type="cancel round small" icon="fa-times" @click="uuids.splice(index, 1)"/>
			</div>
		</div>

        <datatablepaging :pageLength="limit" :maxItems="DataTableFilteredItems().length" @update="(options) => { pageOptions = options }" />
        <datatabletextfilter @update="SetFilterText"></datatabletextfilter>
        <datatable :state="dataTableState" :filterState="filters" :filterCheckState="dataTableFilterOptions" :pageState="pageOptions"/>

    	</div>
</template>

<script>
import axios from 'axios';
import datatable from "../components/uicomponents/datatable";
import datatablefilter from "../components/uicomponents/datatablefilter";
import datatabletextfilter from "../components/uicomponents/datatabletextfilter";
import datatablepaging from "../components/uicomponents/datatablepaging";

export default {
  	name: 'AdminOverview',
    components: {
        datatable,
        datatablefilter,
        datatabletextfilter,
        datatablepaging
    },
  	data () {
		return {
			items: [],
     		fields: [
				{ key: 'email', label: this.$t('employee.core.email'), sortable: true, sortDirection: 'desc' },
				{ key: 'lastname', label: this.$t('employee.ui.firstName'), sortable: true, sortDirection: 'desc' },
				{ key: 'firstname', label: this.$t('employee.ui.lastName'), sortable: true, sortDirection: 'desc' },
				{ key: 'active', label: this.$t('setttings.employ.active') },
       			{ key: 'lastlogin', label: this.$t('global.view.lastLogin'), sortable: true, sortDirection: 'desc' },
        		{ key: 'actions', label: 'Actions' }
			  ],
			newUser: {
				command: "registerUser",
				email:"",
				password:"",
				firstname:"",
				lastname:""
			},
			password: "",
			newpassword: "",
			selectedId: "",
			currentUUID:"",
			uuids: [],
			multiuseritems: [],
			multiuserfields: [
				{ key: 'email', label: this.$t('employee.core.email'), sortable: true, sortDirection: 'desc' },
				{ key: 'lastname', label: this.$t('employee.ui.firstName'), sortable: true, sortDirection: 'desc' },
				{ key: 'firstname', label: this.$t('employee.ui.lastName'), sortable: true, sortDirection: 'desc' }
			  ],
      		totalRows: 0,
      		sortBy: null,
      		sortDesc: false,
      		sortDirection: 'asc',
      		filter: null,
			currentPage: 1,
			limit: 10,
        pageOptions:{
            start: 1,
            end: 10
        },
        filters:{
			textsearch: '',
            employeeId: null,
            email: '',
            firstname: '',
            lastname: '',
            active: [true, false],
        },
    }
	},
    computed: {
        sortOptions () {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => { return { text: f.label, value: f.key } })
        },
        buttonStyle () {
            return {
                flex: `1 1 ${100 / 2}%`
            }
        },
        dataTableFilterOptions() {
            let view = this;
            let state = {};
            state.textsearch = {
                hidden: true,
                filterCheck: (data) => {
                    return (data.email.indexOf(view.filters.textsearch) > -1 || data.firstname.indexOf(view.filters.textsearch) > -1 || data.lastname.indexOf(view.filters.textsearch) > -1)
                }
            };
            return state;
        },
        dataTableState(){
            let view = this;
            let state = {};
            let items = Object.values(this.items);

            state = this.$helpers.GetDataTableStateFromKeyLabelObject({
                id: 'Id',
                email: this.$t('employee.core.email'),
                firstname: this.$t('employee.ui.firstName'),
                lastname: this.$t('employee.ui.lastName'),
                active: this.$t('setttings.employ.active'),
                lastlogin: this.$t('global.view.lastLogin'),
            }, items);
            state.data = items;

            state.headerMap.id.hidden = true;
            state.headerMap.lastlogin.DisplayLabel = (i) => i.lastlogin ? view.$helpers.getMomentFromStringTZ(i.lastlogin).format('DD.MM.YY HH:mm') : '-';

            state.headerMap.active.width = '80px';
            state.headerMap.active.clickOptions = {action: ($event, entry) => {
                    if(entry.data.active){
                        view.deactivateUser(entry.data);
                    } else {
                        view.activateUser(entry.data);
                    }
                }};

            state.headerMap['actions'] = {
                width: '230px',
                button:
                    {icon: 'fas fa-user-plus', action: ($event, header) => {
                            view.CreateUserPopup($event);
                        }},
                buttons:[
                    {
                        icon: 'fas fa-eye',
                        tooltip: this.$t('global.view.showProfile'),
                        action: ($event, data) => view.rowClickHandler(data)
                    },
                    {
                        icon: 'fas fa-user-plus',
                        tooltip: this.$t('global.view.register'),
                        action: ($event, data) => view.registerUser(data)
                    },
                    {
                        icon: 'fas fa-key',
                        tooltip: this.$t('comp.ui.changePassword'),
                        action: ($event, data) => view.OpenChangePasswordPopup(data)
                    },
                    {
                        icon: 'fas fa-calendar-times',
                        tooltip: this.$t('global.view.invalidateToken'),
                        action: ($event, data) => view.invalidateToken(data)
                    },
                    {
                        icon: 'fas fa-mobile',
                        tooltip: this.$t('global.view.deactivate2fa'),
                        action: ($event, data) => view.deactivateTwoFactor(data)
                    },
                    {
                        icon: 'fas fa-user-times',
                        tooltip: this.$t('global.view.deleteProfileImage'),
                        action: ($event, data) => view.deleteProfileImage(data)
                    },
                    {
                        icon: 'fas fa-trash',
                        tooltip: this.$t('global.view.deleteUser'),
                        action: ($event, data) => view.deleteUser(data)
                    }
                ]};

            Object.values(state.headerMap).forEach(h => {
                h.sort = true;
                h.align = 'center';
            });

            state.height = '40px';
            return state;
        },
    },
  	created: function () {
        let token = localStorage.getItem('md_token')
        if(this.isBlank(token)){
        	this.returnToIndex();
        } else {
			let claims = this.extractJWTInfo(token);
			if(claims.role === null || claims.role != 'ADMIN'){
				console.log(claims);
				this.returnToIndex();
			} else {
				this.getUsers();
			}

    }
	},
    beforeDestroy() {
  	    let view = this;
  	    requestAnimationFrame(function(){
          document.body.append(view.$parent.$el);
          document.body.removeChild(view.$parent.$el);
          view.$parent.$destroy();
        });

    },
    mounted(){
        this.$helpers.MountViewOnDropdownContainer(this, {locked: true, header: this.$t('global.view.userOverview'), height: 'calc(100vh - 50px)'});
    },
	// methods that implement data logic.
	methods : {
        OpenChangePasswordPopup(user){
            let view = this;
            this.$helpers.OpenPopup({
                header: this.$t('comp.ui.changePassword'),
                width: '600px',
                components: [{
                    type: 'datafill',
                    state: {
                        entries: [
                            {key: 'id', value: user.id},
                            {key: 'password', type: 'password', value: '', label: this.$t('global.view.newPassword')},
                            {key: 'newpassword', type: 'password', value: '', label: this.$t('global.view.repeatNewPassword')},
                        ],
                        selectCallback: (data, datafill) => {
                            datafill.loading = true;
                            view.changePasswordAdmin(data.id, data.password, data.newpassword).then(response => {
                                datafill.Toggle();
                                view.toggleModal(
                                    view.$t('global.ui.success'),
                                    '<p>' + view.$t('global.view.passwordChanged') + '</p>'
                                );
                            }).catch(function (error) {
                                datafill.loading = false;
                                if(error.response != undefined && error.response.data.message != undefined){
                                    view.toggleModal(view.$t('employee.data.error'), '<p>' + view.$t('comp.ui.changeNotPossible') + '</p><p>' + view.$t('comp.ui.tryAgainOrContactAdmin') + '</p>');
                                }
                            })
                        },
                    },
                }],
                centered: true,
            });
        },
  	    CreateUserPopup(){
              let view = this;
              this.$helpers.OpenPopup({
                  header: this.$t('global.view.createUser'),
                  width: '600px',
                  components: [{
                      type: 'datafill',
                      state: {
                          entries: [
                              {key: 'email', type: 'text', value: '', label:this.$t('employee.core.email')},
                              {key: 'firstname', type: 'text', value: '', label:this.$t('employee.ui.firstName')},
                              {key: 'lastname', type: 'text', value: '', label:this.$t('employee.ui.lastName')},
                              {key: 'password', type: 'password', value: '', label:this.$t('comp.ui.password')},
                          ],
                          selectCallback: (data, datafill) => {
                              datafill.loading = true;
                              view.createUser(data).then(response => {
                                  view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.userCreated'), '');
                                  view.getUsers();
                              }).catch(function (error) {
                                  datafill.loading = false;
                                  if(error.response != undefined && error.response.data.message != undefined){
                                      view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.userCreateFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
                                  }
                              })
                          },
                      },
                  }],
                  centered: true,
              });
        },
        DataTableFilteredItems(){
            let view = this;
                let filteredItems = this.dataTableState.data.filter(d => {
                let passed = true;
                for(let x in view.dataTableFilterOptions){
                    let filter = view.dataTableFilterOptions[x];
                    if(!filter.filterCheck(d)) passed = false;
                }
                return passed;
            });
                return filteredItems;
        },
        SetFilterText(text){
            this.filters.textsearch = text;
        },
		isBlank: function (str) {
		    return (!str || /^\s*$/.test(str));
		},
		getQueryStringValue: function (key) {
			  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
		},
		extractJWTInfo: function(token){
      		if (token) return JSON.parse(atob(token.split('.')[1]));
      		return {};

		},
		rowClickHandler(record, index) {
            this.$router.replace({ name: 'Profile', params: { id: record.id } })

		},
		addUUID: function($event) {
          if(!$event) {
              this.uuids.push(this.currentUUID);
              this.currentUUID = '';
          }
          else {
              if($event.key === 'Enter' && this.currentUUID !== '') {
                  this.uuids.push(this.currentUUID);
                  this.currentUUID = '';
              }
          }

		},
		getMultiUserInfo: function() {
			var payload = {
				command: "getMultiUserInfo",
				ids: this.uuids
			};
			let token = localStorage.getItem('md_token')
			let view = this;
			axios({
				method: 'post',
				url: '/api/user',
				headers: {'Authorization': 'Bearer ' + token},
				data: payload
			}).then(response => {
				view.multiuseritems = response.data;
			}).catch(function (error) {
				if(error.response != undefined && error.response.data.message != undefined){
                    view.toggleModal(
                        view.$t('employee.data.error'),
                        view.$t('global.view.userInfoLoadFailed'),
                        view.$t('comp.ui.tryAgainOrContactAdmin')
                    );
				}
			})
		},
		createUser: function (newUser) {
			this.hideCustomModal('createNewUserModal');
      		var payload = newUser;
			let token = localStorage.getItem('md_token')
			let view = this;
			return axios({
				method: 'post',
				url: '/api/user',
				headers: {'Authorization': 'Bearer ' + token},
				data: payload
			})
		},
		getUsers: function () {
			let url = '/api/user?page='+this.currentPage+'&limit='+50;

			let view = this;
			let token = localStorage.getItem('md_token')
			axios({
				ethod: 'get',
				url: url,
				headers: {'Authorization': 'Bearer ' + token}
			}).then(response => {
				view.items = response.data;
				view.totalRows = view.items.length;
			}).catch(function (error) {
				view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.userOverviewLoadFailed'), '');
			})

		},
		activateUser: function(item) {
			this.$modal.show('dialog', {
                title: this.$t('global.view.activateUser'),
                text: '<p>' + this.$t('global.view.sendActivationEmailTo') + ' ' + item.email + '?</p><p>' +
                    this.$t('global.view.actionCannotBeUndone') + '</p>',
				buttons: [
					{
						title: this.$t('settings.ui.cancel'),
						handler: () => {
							this.$modal.hide('dialog')
						}
					},
					{
						title: this.$t('employee.data.ok'),
						handler: () => {
							this.$modal.hide('dialog');
							var payload = {
								command: "requestActivation",
								email: item.email
							}
							let token = localStorage.getItem('md_token')
							let view = this;
							axios({
								method: 'put',
								url: '/api/user',
								headers: {'Authorization': 'Bearer ' + token},
								data: payload
							}).then(response => {
								view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.activationEmailSent'), '');
							}).catch(function (error) {
								if(error.response != undefined && error.response.data.message != undefined){
									view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.emailSendFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
								}
							});

						}
					}
				]
			})
		},
		registerUser: function(item) {

            let view = this;
            this.$helpers.OpenPopup({
                header: view.$t('global.view.registerUser'),
                width: '650px',
                components: [{
                    type: 'datafill',
                    state: {
                        entries: [
                            {key: 'info', type: 'output', value:  this.$t('global.view.sendRegistrationEmailTo') + ' ' + item.email + '?'},
                            {key: 'info2', type: 'output', value: this.$t('global.view.actionCannotBeUndone')},
                        ],
                        selectCallback: (data, datafill) => {
                            datafill.loading = true;
                            let token = localStorage.getItem('md_token');
                            let payload = {
                                command: "requestRegistration",
                                email: item.email,
                                firstname: item.firstname,
                                lastname: item.lastname,
                                service: "mdauth",
                                reactivate: true,
                            };
                            axios({
                                method: 'put',
                                url: '/api/user',
                                headers: {'Authorization': 'Bearer ' + token},
                                data: payload
                            }).then(response => {
                                datafill.Toggle();
                                view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.registrationEmailSent'), '');
                            }).catch(function (error) {
                                datafill.loading = false
                                if(error.response != undefined && error.response.data.message != undefined){
                                    view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.emailSendFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
                                }
                            });

                        },
                        positiveButtonLabel: view.$t('employee.data.ok'),
                        deleteCallback: () => {},
                        negativeButtonLabel: view.$t('settings.ui.cancel'),
                    },
                }],
                centered: true,
            });
		},
		openPasswordChangeModal: function(item){
			this.selectedId = item.id;
			this.showCustomModal('changePasswordModal');
		},
		changePasswordAdmin: function(id, password, newpassword){
			let view = this;
			var payload = {
				command: "updatePasswordAdmin",
				id: id,
				newpassword: newpassword,
				password: password
			}
			let token = localStorage.getItem('md_token')
			return axios({
				method: 'put',
				url: '/api/user',
				headers: {'Authorization': 'Bearer ' + token},
				data: payload
			})
		},
		deactivateUser: function (item) {
      		var payload = {
				command: "deactivateUser",
				id: item.id
			}
			let token = localStorage.getItem('md_token')
			let view = this;
			axios({
				method: 'put',
				url: '/api/user',
				headers: {'Authorization': 'Bearer ' + token},
				data: payload
			}).then(response => {
				view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.userDeactivated'), '');
				item.active = false;

			}).catch(function (error) {
				if(error.response != undefined && error.response.data.message != undefined){
					view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.deactivationFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
				}
			})
		},
		resetLoginCount: function (item) {
      		var payload = {
				command: "resetLoginAttempts",
				id: item.id
			}
			let token = localStorage.getItem('md_token')
			let view = this;
			axios({
				method: 'put',
				url: '/api/user',
				headers: {'Authorization': 'Bearer ' + token},
				data: payload
			}).then(response => {
				view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.loginAttemptsReset'), '');

			}).catch(function (error) {
				if(error.response != undefined && error.response.data.message != undefined){
					view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.resetFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
				}
			})
		},
		deactivateTwoFactor: function (item) {
      		var payload = {
				command: "deactivateTwoFactor",
				id: item.id
			}
			let token = localStorage.getItem('md_token')
			let view = this;
			axios({
				method: 'put',
				url: '/api/user',
				headers: {'Authorization': 'Bearer ' + token},
				data: payload
			}).then(response => {
				view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.twoFactorDisabled'), '');
				item.twofactor = false;

			}).catch(function (error) {
				if(error.response != undefined && error.response.data.message != undefined){
					view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.deactivationFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
				}
			})
		},
		invalidateToken: function (item) {
      		var payload = {
				command: "updateValidity",
				id: item.id
			}
			let token = localStorage.getItem('md_token')
			let view = this;
			axios({
				method: 'put',
				url: '/api/user',
				headers: {'Authorization': 'Bearer ' + token},
				data: payload
			}).then(response => {
				item.active = false;
				view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.loginTokenInvalidated'), '');
			}).catch(function (error) {
				if(error.response != undefined && error.response.data.message != undefined){
					view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.loginTokenInvalidateFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
				}
			})
		},
		deleteUser: function(item) {
            let view = this;
            this.$helpers.OpenPopup({
                header: this.$t('global.view.deleteUserHeader'),
                width: '650px',
                components: [{
                    type: 'datafill',
                    state: {
                        entries: [
                            {key: 'info', type: 'output', value: this.$t('global.view.confirmDeleteUser') + ' ' + item.email + '?'},
                            {key: 'info2', type: 'output', value: this.$t('global.view.actionCannotBeUndone')},
                        ],
                        selectCallback: (data, datafill) => {
                            datafill.loading = true;
                            let token = localStorage.getItem('md_token')
                            axios({
                                method: 'delete',
                                url: '/api/user?id='+item.id,
                                headers: {'Authorization': 'Bearer ' + token}
                            }).then(response => {
                                view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.userDeleted'), '');
                                view.items = view.items.filter(i => i !== item);
                            }).catch(function (error) {

                                datafill.loading = false;
                                if(error.response != undefined && error.response.data.message != undefined){
                                    view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.userDeleteFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
                                }
                            });
                        },
                        positiveButtonLabel: view.$t('employee.data.ok'),
                        deleteCallback: () => {},
                        negativeButtonLabel: view.$t('settings.ui.cancel'),
                    },
                }],
                centered: true,
            });
		},
		deleteProfileImage: function(item, index) {
  	        let view = this;
            this.$helpers.OpenPopup({
                header: this.$t('global.view.deleteProfileImageHeader'),
                width: '700px',
                components: [{
                    type: 'datafill',
                    state: {
                        entries: [
                            {
                                key: 'info',
                                type: 'output',
                                value: this.$t('global.view .confirmDeleteProfileImage') + ' ' + item.email + '?'
                            },
                            {key: 'info2', type: 'output', value: this.$t('global.view.actionCannotBeUndone')},
                        ],
                        selectCallback: (data, datafill) => {
                            datafill.loading = true;
                            let token = localStorage.getItem('md_token')
                            axios({
                                method: 'delete',
                                url: '/api/profileimage?id='+item.id,
                                headers: {'Authorization': 'Bearer ' + token}
                            }).then(response => {
                                view.toggleModal(view.$t('global.ui.success'), view.$t('global.view.profileImageDeleted'), '');

                            }).catch(function (error) {
                                datafill.loading = false;
                                if(error.response != undefined && error.response.data.message != undefined){
                                    view.toggleModal(view.$t('employee.data.error'), view.$t('global.view.profileImageDeleteFailed'), view.$t('comp.ui.tryAgainOrContactAdmin'));
                                }
                            });
                        },
                        positiveButtonLabel: view.$t('employee.data.ok'),
                        deleteCallback: () => {},
                        negativeButtonLabel: view.$t('settings.ui.cancel'),
                    },
                }],
                centered: true,
            });
		},
		returnToIndex: function(){
			this.$router.replace('/');
		},

		onFiltered (filteredItems) {
			this.totalRows = filteredItems.length
		},
		showCustomModal: function(modal){
			this.$modal.show(modal);
		},
		hideCustomModal: function(modal){
			this.$modal.hide(modal);
		},
		toggleModal(title, text, text2) {
        this.$helpers.OpenInfoPopup(title, [text, text2]);
		},
	},
	watch: {

  	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.admin-overview {
    padding: 40px 40px;
    width: calc(100vw - 200px);
}

  .paging, .text-filter, .filter{
    top: 110px;
  }

.text-filter{
  right: 120px;
  width: 300px;
}
.filter{
  right: 95px;
}

  .uuid{
    box-shadow: inset 0 0 1px 1px var(--contrast-3);
    height: 30px;
    width: calc(100% - 100px) !important;
    margin: 0 !important;
    margin-left: 50px !important;
    margin-bottom: -1px !important;
    padding: 6px 5px;
  }

  .uuid.last{
    margin-bottom: 10px !important;
  }
</style>
